import { useCallback } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $patchStyleText } from '@lexical/selection';
import { css } from '@linaria/atomic';
import { $isRangeSelection, $getSelection } from 'lexical';
import { FontPickerAction } from '../../molecules';
import { useToolbarState } from '../../providers';
import { $patchDynamicFieldLabelStyle } from '../../utils/node-helpers';

const fontPickerFontPickerActionStyle1 = css`
  width: 140px;
  min-width: 140px;
  max-width: 260px;
  flex: 1;
`;

export const FontPicker = () => {
  const [editor] = useLexicalComposerContext();
  const { fontFamily } = useToolbarState(['fontFamily']);

  const onFontFamilySelect = useCallback(
    (option: string) => {
      editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          $patchStyleText(selection, {
            'font-family': option,
          });
        }
        $patchDynamicFieldLabelStyle(selection, { fontFamily: option });
      });
    },
    [editor]
  );

  return (
    <FontPickerAction className={fontPickerFontPickerActionStyle1} value={fontFamily} onChange={onFontFamilySelect} />
  );
};

FontPicker.displayName = 'FontPicker';
